import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { IOrder, IState, IParkerProfileData, IAdditionalVehicles, IAdditionalEmails, IContactShort, ILotList, IParkerProfileQuery, IParkerProfileDetail, ICompaniesShortList, ISpaceEmailUsers, ILotRateList, IStallTypes, IApnSpaceEmailLink, ISpaceEmailByEntityId, IParkersReadyForactivation, IParkerActivationReturnData, IParkerMassUpdateCompany, IParkerMassUpdateRate, IParkerMassUpdateParkerPayType, IParkerMassUpdateInvoiceDeliveryMethod, IParkerMassUpdate, ISettingsState, IParkerProfileForParkerTable, IParkerProfileImportResult, IMarketCompanyRatesByLotNumberWithCompanyId, IUniqueMarketRatesForLotNumber, IParkerSpaceUpdateCriteria, IParkerDeleteSpaceEmailAccount, ISpaceDeleteSpaceEmailLink, ICompanyDetail, ISpaceEmailUsersQueryResult, ISpaceEmailQueryForEmailUpdate, ILotDisableSpace, IInvoiceListWithBalance, IInvoiceAdminQueryResults, ILotUsageMetrics, IApnSpaceRefund, IPaymentDeclineTransaction, ICompanySearchCriteria, ICompanyQueryCriteria, ICompanyNew, ICompanyUpdate, ICompanySpaceEmailLink, IParkerCompanyList, IAdditionalContact, INewAdditionalContact, IUpdatedditionalContact, IParkersFourUp, IUpdateParkerTermDatesByCompany, ICompanyExportDetail, ICompanySpaceFlagData, IAdminAllCompanySearch, ICompanyProfileForCompanyTable, ICompanyProfileImportResult, IParkersNonActiveSpaceAccounts, INonActiveAccountResendRequest, IParkerAdminSearchResults, ILeaseDetail, IUploadedDocumentDetail, INewLeaseData, IUpdateExistingLeaseData, ISpaceCompanyAdmin} from '../../../shared/interfaces';
import { UtilitiesService } from '../helper/utilities.service';
import { environment } from 'src/environments/environment';
import { Contacts } from 'src/app/shared/data/contact';


const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };


@Injectable()
export class DataTestService {
    baseUrl: string = '';
    spaceBaseUrl: string = '';
    parkersUrl = 'parker';
    adminUrl = 'admin';
    ordersUrl = 'orders';
    companyUrl = 'company';
    spaceUrl = 'space';
    userUrl = 'user';
    invoiceUrl = 'invoice';
    utilityUrl = 'utility';
    lotUrl = 'lot';
    documentUrl = 'document'
    orders: IOrder[] = [];
    states: IState[] = [];

    constructor(private http: HttpClient) {
        this.baseUrl = environment.RestServer;  
        this.spaceBaseUrl = environment.SpaceRestServer;  
        
    }

    

    isParkerControllerAlive(): Observable<string>{
        return this.http.get<string>(`${this.baseUrl}${this.parkersUrl}/isparkercontrolleralive`, httpOptions)
    }
}